import React, { useState } from "react";
import { Link } from "react-router-dom";
import Toodhulogo from "./images/Toodhulogo.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import icon1 from "./images/icon1operation.webp";
import icon2 from "./images/icon2synergy.webp";
import explorearrow from "./images/explorearrow.svg";

function NavbarComponent() {
  const [isOpen, setIsOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);

  const products = [
    { title: "Operation 360", description: "Simplify customer relations and business operations by efficiently managing interactions, sales, and support to enhance customer satisfaction and operational effectiveness.", link: "/operation360", icon: icon1 },
    { title: "Synergy 360", description: "Enhance collaboration and workflow integration by connecting teams, departments, and stakeholders to improve coordination, communication, and productivity.", link: "/synergy360", icon: icon2 }
  ];

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm px-4 rounded-pill" id="navy">
      <div className="container" style={{ maxWidth: "1200px" }}>
        <Link to="/" className="navbar-brand me-4">
          <img src={Toodhulogo} alt="Logo" />
        </Link>

        {/* Mobile View - Login and Hamburger Icon */}
        <div className="d-flex align-items-center d-lg-none">
          <a href="https://toodhu.com/demo/">
            <button className="btn btn-dark rounded-pill me-2">Log in →</button>
          </a>
          <button onClick={() => setIsOpen(true)} className="navbar-toggler">
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>

        {/* Full-Screen Mobile Menu */}
        {isOpen && (
          <div className="fixed-top bg-white vh-100 p-4 z-50 overflow-auto">
            <div className="d-flex justify-content-between">
              <Link to="/" className="navbar-brand">
                <img src={Toodhulogo} alt="Logo" />
              </Link>
              <button onClick={() => setIsOpen(false)} className="btn-close"></button>
            </div>
            <ul className="list-unstyled mt-4 text-start p-4 listedmenus "> {/* Left aligned */}
              {/* Products with Toggle Dropdown */}
              <li className="">
  <p className="mb-2 menulistings">Products</p>
  <ul className="list-unstyled ps-3 mt-2 ">
    {products.map((product, index) => (
      <li key={index} className="mb-2 d-flex">
        <img src={product.icon} alt={product.title} className="me-2" style={{ width: '30px', height: '30px' }} />
        <div>
          <Link to={product.link} className="text-decoration-none fw-bold text-black">{product.title}</Link>
          <p style={{ fontSize: "12px" }}>{product.description}</p>
          <a href={product.link} className="text-decoration-none text-primary" target="_self" rel="noopener noreferrer">
  Explore <img src={explorearrow} alt="Explore" />
</a>
        </div>
      </li>
    ))}
  </ul>
</li>
              <li className="menulistings"><Link to="/pricing" className="text-decoration-none">Pricing</Link></li>
              <li className="menulistings"><Link to="/customers" className="text-decoration-none">Customer</Link></li>
              <li className="menulistings"><Link to="/blogpage" className="text-decoration-none">Blog</Link></li>
              <li className="menulistings"><Link to="/contactform" className="text-decoration-none">Contact us</Link></li>
            </ul>
          </div>
        )}

        {/* Desktop View */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto">
            <li className="nav-item dropdown">
              <Link className="nav-link dropdown-toggle" href="#" id="productsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Products</Link>
              <div className="dropdown-menu p-3" aria-labelledby="productsDropdown" style={{ minWidth: '595px' }}>
                <div className="row">
                  {products.map((product, index) => (
                    <div key={index} className="col-6 d-flex">
                      <img src={product.icon} alt={product.title} className="me-2" style={{ width: '40px', height: '40px' }} />
                      <div>
                        <h6 className="fw-bold">{product.title}</h6>
                        <Link to={product.link} style={{ textDecoration: 'none' }}>
                          <p className="mb-1" style={{ fontSize: '10px', fontWeight: 400,color:'black' }}>
                            {product.description}
                          </p>
                        </Link>
                        <Link to={product.link} className="explorearrowtxt">Explore <img src={explorearrow}/></Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </li>
            <li className="nav-item"><Link className="nav-link" to="/pricing">Pricing</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/customers">Customer</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/blogs">Blog</Link></li>
          </ul>

          {/* Contact and Login Button */}
          <div className="d-none d-lg-flex align-items-center">
            <Link to="/contactform" className="nav-link me-3">Contact us</Link>
<a href="/ProjectSelection.htm" target="_blank"> {/* Changed 'p' to 'P' for consistency with filename */}
  <button className="btn btn-dark rounded-pill">Log in &rarr;</button>
</a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavbarComponent;